import { hexToRGB } from '@repo-level/core-front';
import { device } from 'components/styles/MediaQuery';
import styled, { css } from 'styled-components/macro';

export interface ScSliderProps {
  pagination: boolean;
  isInsideArrow: boolean;
  isDesktop: boolean;
  slidesNumber: number;
  isSliderSection: boolean;
}

export const ScSlider = styled.div<ScSliderProps>`
  position: relative;

  .last {
    height: auto;
  }

  .no-result {
    width: 100%;
    font-size: 12px;
    line-height: 1.67;
    color: ${({ theme }) => theme.secondaryColor};
  }

  .swiper {
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
    ${({ isDesktop }) =>
      !isDesktop &&
      css`
        overflow: inherit;
      `}
    ${({ isSliderSection, isDesktop }) =>
      isSliderSection &&
      isDesktop &&
      css`
        padding-inline: 2px;
      `}
  }

  .swiper-pagination {
    position: absolute;
    right: 72px;
    top: 296px;
    z-index: 2;
    gap: 4px;
    width: 220px;
    display: grid;
    grid-template-columns: ${({ slidesNumber }) =>
      `repeat(${slidesNumber}, 1fr)`};

    @media (${device.mobile}) {
      right: 16px;
      top: 306px;
      width: auto;
      display: flex;
    }
  }

  .swiper-pagination-bullet {
    cursor: pointer;
    &:before {
      position: relative;
      content: '';
      width: 100%;
      height: 8px;
      display: block;
      border-radius: 2px;
      transition: 0.3s;
      background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
    }

    @media (hover: hover) {
      &:hover {
        &:before {
          background: ${({ theme }) => hexToRGB(theme.whiteColor, 0.4)};
        }
      }
    }

    &-active {
      &:before {
        background-color: ${({ theme }) => theme.whiteColor};
      }

      @media (hover: hover) {
        &:hover {
          &:before {
            background: ${({ theme }) => theme.whiteColor};
          }
        }
      }
    }

    @media (${device.mobile}) {
      &:before {
        width: 8px;
        height: 8px;
      }
    }
  }
`;

export const ScOutsideContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: end;
  margin-bottom: 16px;

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
  }

  .left-col {
    min-width: 0;
    flex: 1 1 auto;
  }

  .right-col {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-shrink: 0;
  }
`;

interface ScSliderSkeletonProps {
  slidesPerView: number;
}

export const ScSliderSkeleton = styled.div<ScSliderSkeletonProps>`
  display: grid;
  grid-template-columns: ${({ slidesPerView }) =>
    `repeat(${slidesPerView}, 1fr)`};
  grid-column-gap: 16px;
  grid-row-gap: 16px;
`;
